import type { GroupMemberProfile, Match, PaymentRecord, Turf } from '../../types';

export type AdminMember = GroupMemberProfile & { accountEmail?: string | null; accountRole?: string };

export interface AdminOverview {
  members: number;
  pendingApprovals: number;
  activeMembers: number;
  matches: number;
  upcomingMatches: number;
  awaitingReport: number;
  payments: number;
  paymentsPaidTotal: number;
  turfs: number;
  media: number;
  venues: number;
  pendingJoinRequests: number;
  accounts: number;
  recentActivity: Array<{ id: string; action: string; details: string; actorName: string; timestamp: string }>;
}

export interface AdminSettings {
  group: any;
  notificationSettings: Record<string, boolean>;
  privacySettings: Record<string, string>;
}

export interface ApiResult<T> {
  ok: boolean;
  status: number;
  data: T | null;
  error?: string;
}

export async function api<T = unknown>(path: string, options: RequestInit = {}): Promise<ApiResult<T>> {
  const headers: Record<string, string> = { ...((options.headers as Record<string, string>) || {}) };
  if (options.body && !(options.body instanceof FormData) && typeof options.body === 'string') {
    headers['Content-Type'] = 'application/json';
  }
  try {
    const res = await fetch(path, { ...options, headers });
    let data: unknown = null;
    try { data = await res.json(); } catch { data = null; }
    return { ok: res.ok, status: res.status, data: data as T, error: (data as { error?: string })?.error };
  } catch {
    return { ok: false, status: 0, data: null, error: 'Network error — is the server reachable?' };
  }
}

export type { GroupMemberProfile, Match, PaymentRecord, Turf };